import React, { useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import logo from '../images/LOGO.png';

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const handleNavItemClick = (item) => {
    console.log(`Clicked on ${item}`);
    setIsMenuOpen(false); // Close menu on mobile after clicking
  };

  const handleLogoClick = () => {
    window.location.href = '/';
  };

  const customStyles = {
    navbar: {
      backgroundColor: '#efe5c4ff',
      backdropFilter: 'blur(12px)',
      borderBottom: '1px solid rgba(55, 65, 81, 0.3)',
      padding: '1rem 1.5rem'
    },
    logo: {
      height: '60px',
      borderRadius: '50%'
    },
    navLink: {
      color: '#000 !important',
      fontWeight: '600',
      fontSize: '16px',
      margin: '0 0.5rem',
      transition: 'color 0.3s ease'
    },
    loginBtn: {
      backgroundColor: '#14b8a6',
      borderColor: '#14b8a6',
      fontWeight: '500',
      transition: 'all 0.3s ease'
    },
    navbarToggler: {
      borderColor: '#14b8a6',
      color: '#14b8a6'
    }
  };

  return (
    <>
      <style jsx>{`
        .navbar-custom {
          background-color: #efe5c4ff !important;
          backdrop-filter: blur(12px);
          border-bottom: 1px solid rgba(55, 65, 81, 0.3);
        }
        
        .navbar-nav .nav-link {
          color: #000 !important;
          font-weight: 600;
          font-size: 16px;
          margin: 0 0.5rem;
          transition: color 0.3s ease;
        }
        
        .navbar-nav .nav-link:hover {
          color: #14b8a6 !important;
        }
        
        .btn-login {
          background-color: #14b8a6;
          border-color: #14b8a6;
          font-weight: 500;
          transition: all 0.3s ease;
          margin: 0 1em 0 3em;
        }
        
        .btn-login:hover {
          background-color: #0f9c8e;
          border-color: #0f9c8e;
        }
        
        .navbar-toggler {
          border-color: #14b8a6;
          padding: 0.25rem 0.5rem;
          font-size: 1rem;
          width: auto;
          height: auto;
        }
        
        .navbar-toggler:focus {
          box-shadow: 0 0 0 0.25rem rgba(20, 184, 166, 0.25);
        }
        
        .navbar-toggler-icon {
          background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'%3e%3cpath stroke='rgba%2820, 184, 166, 1%29' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e");
          width: 1.5em;
          height: 1.5em;
        }
        
        @media (max-width: 991.98px) {
          .navbar-nav {
            text-align: center;
            padding-top: 1rem;
          }
          
          .navbar-nav .nav-link {
            padding: 0.75rem 0;
            border-bottom: 1px solid rgba(0, 0, 0, 0.1);
          }
          
          .btn-login {
            margin: 1rem 0;
            width: 100%;
          }
        }
        
        .navbar-brand {
          cursor: pointer;
        }
      `}</style>

      <nav className="navbar navbar-expand-lg navbar-custom">
        <div className="container-xl">
          {/* Logo */}
          <div className="navbar-brand" onClick={handleLogoClick}>
            <img 
              src={logo} 
              alt="Logo" 
              style={{...customStyles.logo, height: '90px'}}
              className="d-inline-block align-text-top"
            />
          </div>

          {/* Mobile Toggle Button */}
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarNav"
            aria-controls="navbarNav"
            aria-expanded={isMenuOpen}
            aria-label="Toggle navigation"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          {/* Navigation Menu */}
          <div className={`collapse navbar-collapse ${isMenuOpen ? 'show' : ''}`} id="navbarNav">
            <ul className="navbar-nav ms-auto mb-2 mb-lg-0">
              <li className="nav-item">
                <a
                  className="nav-link"
                  href="/"
                  onClick={() => handleNavItemClick('Home')}
                >
                  Home
                </a>
              </li>
              <li className="nav-item">
                <a
                  className="nav-link"
                  href="/programs"
                  onClick={() => handleNavItemClick('Programs')}
                >
                  Programs
                </a>
              </li>
              <li className="nav-item">
                <a
                  className="nav-link"
                  href="/ai-trainer-kit"
                  onClick={() => handleNavItemClick('AI Trainer Kit')}
                >
                  AI Trainer Kit
                </a>
              </li>
              <li className="nav-item">
                <a
                  className="nav-link"
                  href="/research"
                  onClick={() => handleNavItemClick('Research')}
                >
                  Research
                </a>
              </li>
              <li className="nav-item">
                <a
                  className="nav-link"
                  href="/career"
                  onClick={() => handleNavItemClick('Careers')}
                >
                  Careers
                </a>
              </li>
              <li className="nav-item">
                <a
                  className="nav-link"
                  href="/about"
                  onClick={() => handleNavItemClick('About')}
                >
                  About
                </a>
              </li>
              <li className="nav-item">
                <a
                  className="nav-link"
                  href="/contact-us"
                  onClick={() => handleNavItemClick('Contact')}
                >
                  Contact
                </a>
              </li>
            </ul>
            
            {/* Login Button */}
            <div className="d-flex">
              <a
                href="/login"
                className="btn btn-primary btn-login"
                onClick={() => handleNavItemClick('Login')}
              >
                Join Now
              </a>
            </div>
          </div>
        </div>
      </nav>
    </>
  );
};

export default Navbar;